import React from 'react';
import { Container, Typography, Box, Grid, Card, CardContent, CardMedia, CardActions, Button, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Payment } from '@mui/icons-material';

const Store = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          {t('store.title')}
        </Typography>
        <Typography variant="h5" gutterBottom>
          {t('store.subtitle')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('store.description')}
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {Array.isArray(t('store.products', { returnObjects: true }))
          ? t('store.products', { returnObjects: true }).map((product, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Card elevation={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardMedia
                  component="img"
                  height="250"
                  image={product.image || `/images/products/product${index + 1}.jpg`}
                  alt={product.name}
                  sx={{ objectFit: 'contain', p: 2 }}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" component="h2" gutterBottom>
                    {product.name}
                  </Typography>
                  <Typography variant="h6" color="primary" gutterBottom>
                    {product.price}
                  </Typography>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {product.description}
                  </Typography>
                </CardContent>
                <CardActions sx={{ p: 2, pt: 0 }}>
                  <Button
                    component="a"
                    href={product.paypalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    color="primary"
                    fullWidth
                    startIcon={<Payment />}
                    sx={{
                      bgcolor: '#0070ba',
                      '&:hover': { bgcolor: '#005ea6' }
                    }}
                  >
                    {t('store.buyNow')}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))
          : <Grid item xs={12}><Typography>No products available</Typography></Grid>
        }
      </Grid>
    </Container>
  );
};

export default Store;